import React from 'react';
import { Container } from '@landr/maestro';
import { PrismicHTML } from 'components/Prismic';
import './TextBlock.scss';
import { PrismicRichTextFieldType } from '../types';
import { SupportedPrismicSlicesEnum } from '../enums';

type TextBlockProps = {
    slice: {
        type: SupportedPrismicSlicesEnum.textBlock;
        primary: {
            text_block_content: PrismicRichTextFieldType;
        };
    };
};

const TextBlock = ({ slice }: TextBlockProps) => {
    return (
        <Container size="xl" py="mg">
            <PrismicHTML content={slice.primary.text_block_content} />
        </Container>
    );
};

export { TextBlock, TextBlockProps };
